module.exports = __webpack_public_path__ + "img/plw.20a1d020.svg";